import { render, staticRenderFns } from "./addEscort.vue?vue&type=template&id=035bab78&scoped=true&"
import script from "./addEscort.vue?vue&type=script&lang=js&"
export * from "./addEscort.vue?vue&type=script&lang=js&"
import style0 from "./addEscort.vue?vue&type=style&index=0&id=035bab78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035bab78",
  null
  
)

export default component.exports